






























































import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Validator } from 'vee-validate';
import { Base } from '@/components/common/base';
import { Richtext } from 'dhx-richtext';
import 'dhx-richtext/codebase/richtext.css';
import { IDialogOption } from '@/models/dialog';
import * as marked from 'marked';
import * as dhx from 'dhx-richtext';
import { getHeaders } from '@/views/fileBunker/depositlog/depositlog';
import {depositLogService} from '@/shared';

@Component({
    props: ['dialog', 'recordKey', 'notes'],
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () =>
            import('@/components/common/app.dialog.vue'),
        Richtext,

    },
    computed: {
        previewText() {
            return marked(this.md_text);
        },
    },
})
export default class NoteComponent extends Base {
    get trigger(): boolean {
        return this.$props.dialog;
    }
    set trigger(val) {
        this.$emit('closedialog', val);
    }

    public $validator: Validator;
    public headers: VHeaders[] = getHeaders(this);
    public loading: boolean = false;
    public pagination = new PaginationModel('createdAt', true, 5);
    public actions: any[] = [];
    public items: any[] = [];
    public dialog: boolean;
    public noteTextToDisplay: string = '';
    public recordKey: string;
    public noteText: string = '';
    public noteId: string = '';
    public html: string = '';
    public requestProgress: boolean = false;

    public css: string = '';
    public mode: { type: string; default: 'classic' };
    public value: string = '';
    public dataType: { type: string; default: 'markdown' };
    public richtext: any;
    public markdown: string = '';

    public NoteDialog: IDialogOption = {
        width: 800,
        title: this.$parent.$t('depositLogNote.noteDialog.title') as string,
        model: false,
    };
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('depositLogNote.deleteDialog.title') as string,
        model: false,
        loading: false,
        action: { color: 'success', icon: 'fas fa-check',
        text: this.$parent.$t('depositLogNote.deleteDialog.lblAgree') as string },
        onAction: (): void => {
            this.deleteNote();
        },
    };

    public setActions() {
        this.actions = [
            {
                type: 'button',
                icon: 'fas fa-eye',
                title: this.$t('depositLogNote.gridHeaders.gridAction.view') as string,
                color: 'primary',
                action: (val) => {
                    this.showNote(val.noteText);
                },
            },
            {
                type: 'button',
                icon: 'fas fa-trash-alt',
                title: this.$t('depositLogNote.gridHeaders.gridAction.delete') as string,
                color: 'error',
                action: (val) => {
                    this.confirmDelete(val.id);
                },
            },

        ];
    }
    public showNote(item: any): void {
        this.noteTextToDisplay = marked(item);
        this.NoteDialog.model = true;
    }

    public confirmDelete(id: string): void {
        this.deleteDialog.model = true;
        this.noteId = id;
    }
    public async deleteNote(): Promise<void> {
        const vm = this;
        try {
            this.deleteDialog.loading = true;
            await depositLogService.deleteNote(this.$props.recordKey, vm.noteId);
            const index = vm.$props.notes.findIndex((x) => x.id === vm.noteId);
            if (index !== -1) {
                vm.$props.notes.splice(index, 1);
            }

            vm.getNotes();
            vm.showAlert(true, this.$t('depositLogNote.alertNoteDelete'));
        } finally {
            this.deleteDialog.loading = true;
            vm.deleteDialog.model = false;
        }
    }
    public created() {
        dhx.i18n.setLocale('richtext', this.$t('richText'));
    }


    public mounted() {
        this.setActions();
        this.richtext = new Richtext(this.$refs.container, {
            mode: this.mode,
            css: this.css,
        });
        const vm = this;
        this.$watch('recordKey', (newVal, oldVal) => {
            this.getNotes();
        });
    }
    public async getNotes(): Promise<void> {
        try {
            this.loading = true;
            this.items = [];
            this.items = this.$props.notes;
            if (this.items) {
                this.pagination.totalItems = this.items.length || 0;
            }
        } finally {
            this.loading = false;
        }
    }

    public async saveNote(): Promise<void> {
        try {
            this.noteText = this.richtext.getValue('markdown');
            if (!this.noteText) {
                this.showAlert(false, this.$t('depositLogNote.alertNoteEmpty'));
                return;
            }

            this.requestProgress = true;
            const response = await depositLogService.addNote(
                this.$props.recordKey,
                this.noteText,
            );

            this.noteText = '';
            this.markdown = '';
            this.richtext.setValue(this.markdown, this.dataType);

            this.$props.notes.push(response);
            this.getNotes();
            this.showAlert(true, this.$t('depositLogNote.alertNoteAdded'));
            this.$validator.reset();
        } finally {
            this.requestProgress = false;
        }
    }

    public closeDialog() {
        this.trigger = false;
        this.$validator.reset();
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }
}
